import React from "react";
import { useTheme } from "styled-components";
import Icon from "../../../components/ui/Icon";
import Logo from "../../../components/ui/Logo";
import { Header, CartButton, Badge } from "./TopBar.styles";

interface TopBarProps {
  count: number;
  /** Ausente no cardápio-vitrine (/menu): sem sacola, o botão some. */
  onCart?: () => void;
  onLogo?: () => void;
}

export default function TopBar({ count, onCart, onLogo }: TopBarProps) {
  const theme = useTheme();

  return (
    <Header>
      <Logo size={24} light onClick={onLogo} />
      {onCart && (
        <CartButton type="button" onClick={onCart} aria-label="Ir para o carrinho">
          <Icon name="bag" size={21} color={theme.tokens.colors.surface} />
          {count > 0 && <Badge>{count}</Badge>}
        </CartButton>
      )}
    </Header>
  );
}
